import { chunk, get, noop } from 'lodash'
import React from 'react'
import { Row } from 'react-bootstrap'

import { OnChange } from '../../../../../Field'
import { IFilter } from '../../../../types'

interface RenderFilterModeProps {
  filterMode: string
  filters: IFilter[]
  setFilter: (filter: IFilter) => void
  renderFilter: (filter: IFilter, index: number) => React.ReactNode
}

const RenderFilterMode = (props: RenderFilterModeProps): React.ReactElement => {
  const { filterMode, filters = [], renderFilter, setFilter = noop } = props

  if (filterMode === 'detail') {
    return (
      <>
        {!get(filters[0], 'colWidth') ? (
          chunk(filters, 2).map((chunk, chunkIndex) => {
            return (
              <Row
                className={`${chunkIndex === 0 ? 'mt-2' : ''}`}
                key={chunkIndex}
              >
                {chunk.map((filter, index) => {
                  if (!filter.exludeForDetail) {
                    return (
                      <>
                        {renderFilter(filter, index)}
                        <OnChange
                          name={filter.name as string}
                          onChange={(value) => {
                            setFilter({ name: filter.name, value })
                          }}
                        />
                      </>
                    )
                  }
                })}
              </Row>
            )
          })
        ) : (
          <Row>
            {filters.map((filter, index) => {
              if (!filter.exludeForDetail) {
                return (
                  <>
                    {renderFilter(filter, index)}
                    <OnChange
                      name={filter.name as string}
                      onChange={(value) => {
                        setFilter({ name: filter.name, value })
                      }}
                    />
                  </>
                )
              }
            })}
          </Row>
        )}
      </>
    )
  }

  if (filterMode === 'fulltext') {
    return (
      <React.Fragment>
        {filters.map((filter, index) => {
          if (filter.type === 'fulltext' || filter.showForFts) {
            return (
              <Row className="mt-2" key={index}>
                {renderFilter(filter, index)}
                <OnChange
                  name={filter.name as string}
                  onChange={(value) => {
                    setFilter({ name: filter.name, value })
                  }}
                />
              </Row>
            )
          }
        })}
      </React.Fragment>
    )
  }
  return <></>
}

export default RenderFilterMode
